import { AnimationConfigWithPath } from "lottie-web";

export const defaultLottieOptions: Partial<AnimationConfigWithPath> = {
  renderer: "svg",
  loop: true,
  autoplay: true,
};
